import { client } from "../client/client";

export const getloanTransactions = async (
  loanId,
  page,
  limit,
  fromDate,
  toDate,
  search,
  status,
  method,
  type,
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (fromDate) params.append("paymentDateFrom", fromDate);
    if (toDate) params.append("paymentDateTo", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (method) params.append("method", method);
    if (type) params.append("type", type);

    const response = await client.get(
      `/loans/${loanId}/transactions?${params.toString()}`,
    );
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
export const getTransactions = async (
  page,
  limit,
  fromDate,
  toDate,
  search,
  status,
  method,
  type,
  minAmount,
  maxAmount,
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (fromDate) params.append("dateFrom", fromDate);
    if (toDate) params.append("dateTo", toDate);
    if (search) params.append("q", search);
    if (status) params.append("status", status);
    if (method) params.append("paymentMethod", method);
    if (type) params.append("transactionType", type);
    if (minAmount) params.append("minAmount", minAmount);
    if (maxAmount) params.append("maxAmount", maxAmount);

    const response = await client.get(`/transaction?${params.toString()}`);
    return response;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const makeManualPayment = async (
  loanId,
  amount,
  paymentDate,
  method,
  paymentReference,
  note,
  file,
) => {
  try {
    const formData = new FormData();
    formData.append("amount", amount);
    formData.append("paymentDate", paymentDate);
    formData.append("method", method);
    formData.append("paymentReference", paymentReference);
    formData.append("note", note);
    if (file) {
      formData.append("receipt", file);
    }
    const response = await client.post(
      `/loans/${loanId}/manual-payment`,
      formData,
    );

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
